import type { LucideIcon } from 'lucide-react';
import { ShoppingCart, Package, ShoppingBag, Store, Tag, Building2, Handshake, Gavel } from 'lucide-react';

/**
 * Multi-vendor marketplace inboxes on the expansion roadmap. These are shown as
 * "coming soon" on the Integrations page — each maps to a real per-platform
 * webhook → normalize → RAG-reply → send-message connector (see
 * docs/integrations/noorbot-mono-COMMERCE-PLATFORM-EXPANSION-ROADMAP.md).
 * Regions drive the ordering so the flagship markets (South Asia / Gulf) lead.
 */
export interface MarketplaceMeta {
  key: string;
  name: string;
  description: string;
  region: string;
  icon: LucideIcon;
}

export const marketplaceMeta: MarketplaceMeta[] = [
  { key: 'daraz', name: 'Daraz', description: 'Seller chat auto-reply across Daraz storefronts', region: 'South Asia', icon: Package },
  { key: 'lazada', name: 'Lazada', description: 'Reply to buyer chats via the Lazada IM API', region: 'Southeast Asia', icon: ShoppingBag },
  { key: 'shopee', name: 'Shopee', description: 'Answer Shopee Chat messages automatically', region: 'Southeast Asia', icon: Store },
  { key: 'ebay', name: 'eBay', description: 'Respond to eBay member & post-order messages', region: 'UK / Global', icon: Gavel },
  { key: 'mercadolibre', name: 'Mercado Libre', description: 'Reply to questions & post-sale messages', region: 'Latin America', icon: Handshake },
];
